import { Loader } from 'lucide-react';
import Circle from '../assets/circle.png';

type CircleProps = {
  size?: number;
};

export function CircleLoader({ size }: CircleProps) {
  return (
    <div className="flex items-center justify-center h-screen">
      <div
        className={`relative w-${size ?? 10 * 4} h-${size ?? 10 * 4} animate-in repeat-infinite spin-in-360 duration-3600`}
      >
        <img
          src={Circle}
          alt="Círculo de invocación"
          className="w-full h-full object-contain"
        />
        <div
          className={`absolute inset-${size ?? 10} flex items-center justify-center text-yellow-400 font-bold text-xs text-center`}
        />
      </div>
    </div>
  );
}

export function BaseLoader() {
  return (
    <div className="w-full h-svh flex justify-center items-center">
      <Loader className="animate-spin" size={32} />
      <span className="sr-only">loading</span>
    </div>
  );
}

/**
 * Spinner del tamaño de una línea de texto, para listas y popovers.
 *
 * `BaseLoader` mide `h-svh`: adentro de un contenedor con `max-h-64` centra el
 * spinner a media pantalla, o sea fuera de lo que se ve, y el resultado es una
 * caja vacía que parece un listado sin resultados.
 */
export function InlineLoader({ label }: { label?: string }) {
  return (
    <div className="flex items-center justify-center gap-2 p-3 text-sm text-muted-foreground">
      <Loader className="h-4 w-4 animate-spin" />
      {label ? <span>{label}</span> : <span className="sr-only">loading</span>}
    </div>
  );
}
